export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoic2Fsby1jYmEiLCJhIjoiY2pwMjcwcHZrMDQ2MTN1bnY4b2RrbjllMSJ9.nv4JZUvZNTvnAEw3KdmXzA';
export const MAP_BOUNDS = [
  [44, -110],
  [30, -135],
];
export const MAP_LATLNG = [37.19795254960319, -120.85479187251866];
export const MAP_DEFAULT_ZOOM = 7;

export default MAPBOX_ACCESS_TOKEN;
